module.exports = __webpack_public_path__ + "img/MD.60c4994b.png";